import { IFetalDiagnosis, IFetchFetalDiagnosesParams } from '~/interfaces'
import { axios, AxiosResponse } from '~/modules'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchFetalDiagnoses = async (params: IFetchFetalDiagnosesParams): Promise<IFetalDiagnosis[]> => {
  const { pathParams } = params
  const response = await axios.get(`${hstoryAPI}/pregnancies/${pathParams.pregnancyId}/fetal-diagnoses`)
  const { data }: AxiosResponse<IFetalDiagnosis[]> = response
  return data
}
